// Meta Pixel tracking utilities

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initMetaPixel = () => {
  if (typeof window === 'undefined') return

  // Check if Meta Pixel is already loaded
  if (window.fbq) return // Load Meta Pixel script
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return

    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })

    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const t = b.createElement(e)
    t.async = true
    t.src = v

    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      // Fallback: append to head if no script tags exist
      b.head.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  // Initialize with your Pixel ID
  window.fbq('init', '2169607650508214')

  // Track initial PageView
  window.fbq('track', 'PageView')
}

export const trackAddToCart = (value?: number, currency: string = 'COP') => {
  if (typeof window === 'undefined' || !window.fbq) return

  window.fbq('track', 'AddToCart', {
    value: value || 21900,
    currency: currency,
    content_name: 'Protocolo Adiós Barriga Hormonal en 21D',
    content_type: 'product',
  })
}

export const trackPurchase = (value: number, currency: string = 'COP') => {
  if (typeof window === 'undefined' || !window.fbq) return

  window.fbq('track', 'Purchase', {
    value: value,
    currency: currency,
  })
}
